export default class RelationHelper {
    constructor(data) {
        this.data = data;
    }

    find(root, type, ...relationChain) {
        return relationChain.reduce(([lastNode, lastType], relation) => {
            if (lastNode instanceof Array) {
                const items = lastNode.map(_lastNode => this._findOne(_lastNode, lastType, relation));

                if (items.length === 0) {
                    return [[], ''];
                }

                return [items.map(t => t[0]), items[0][1]];
            }

            return this._findOne(lastNode, lastType, relation);
        }, [root, type])[0];
    }

    _findOne(lastNode, lastType, relation) {
        let many = false;
        if (relation.endsWith('[]')) {
            many = true;
            relation = relation.substring(0, relation.length - 2);
        }

        const finder = many ? 'filter' : 'find';

        const parseRelParts = (delimiter) => {
            const parts = relation.split(delimiter);

            const relationType = parts[1];
            const relationField = (parts[0] || (delimiter === '<-' ? lastType : relationType)) + '_id';

            return [relationField, relationType];
        };

        if (relation.includes('->')) {
            const [relationField, relationType] = parseRelParts('->');

            const relationNode = this.getRelationData(relationType)[finder](item => lastNode[relationField] === item['id']);

            return [relationNode, relationType];
        }

        const [relationField, relationType] = parseRelParts('<-');

        const relationNode = this.getRelationData(relationType)[finder](item => lastNode['id'] === item[relationField]);

        return [relationNode, relationType];
    };

    getRelationData(relationType) {
        if (this.data.hasOwnProperty(relationType)) {
            return this.data[relationType];
        }

        console.log('Relations:', this.data);

        throw new Error(`Relation type not found: ${relationType}`);
    }
}

/**
relationHelper.find(item, 'product',
    'detailed_image_of_product[]',
    'image',
    'avatar_image<-article[]',
    [
        'article_category',
        [
            'tag_of_article[]',
            'tag',
            'tag_of_product[]',
            'product',
        ]
    ]
);

relationHelper.find(item, 'product',
    'product<-detailed_image_of_product[]',
    'image',
    'avatar_image<-article[]',
    [
        'article_category',
        [
            'tag_of_article[]',
            'tag',
            'tag_of_product[]',
            'product',
        ]
    ]
);

 1-1: 'product', 'avatar_image'
 1-M: 'product', 'product.detailed_image_of_product[]'
 M-M: 'product', 'product.detailed_image_of_product[]', 'image'
 Mix: 'product', 'product.detailed_image_of_product[]', 'image', 'avatar_image.article[]'
 Mix: 'product', 'product.detailed_image_of_product', 'image', 'avatar_image.article[]'
 Mix: 'product', '.detailed_image_of_product[]', 'image', 'avatar_image.article[]'
 Mix: 'product', '.detailed_image_of_product', 'image', 'avatar_image.article[]'

 1-1: 'product', 'avatar_image'
 1-M: 'product', 'product..detailed_image_of_product[]'
 M-M: 'product', 'product..detailed_image_of_product[]', 'image'
 Mix: 'product', 'product..detailed_image_of_product[]', 'image', 'avatar_image..article[]'
 Mix: 'product', 'product..detailed_image_of_product', 'image', 'avatar_image..article[]'
 Mix: 'product', '..detailed_image_of_product[]', 'image', 'avatar_image..article[]'
 Mix: 'product', '..detailed_image_of_product', 'image', 'avatar_image..article[]'


 1-1: 'product', 'avatar_image->image'
 1-M: 'product', 'product<-detailed_image_of_product[]'
 M-M: 'product', 'product<-detailed_image_of_product[]', '->image'
 Mix: 'product', 'product<-detailed_image_of_product[]', '->image', 'avatar_image<-article[]'
 Mix: 'product', 'product<-detailed_image_of_product', '->image', 'avatar_image<-article[]'
 Mix: 'product', '<-detailed_image_of_product[]', '->image', 'avatar_image<-article[]'
 Mix: 'product', '<-detailed_image_of_product', '->image', 'avatar_image<-article[]'

*/